import React from 'react';
import { Bar, Doughnut, PolarArea } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ArcElement,
	RadialLinearScale
} from 'chart.js';

import getColor from '../../../services/chartColors';

// Register Chart.js components
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ArcElement,
	RadialLinearScale
);

function Chart(props) {
	const [typeChart, setTypeChart] = React.useState('bar');

	let total = 0;
	props.data.data.forEach((cant) => {
		total = total + cant;
	});

	if (total === 0) {
		return (
			<React.Fragment>
				<div>
					<h6>Opciones disponibles:</h6>
					<ul>
						{props.options.map((option, index) => {
							return <li key={index}>{option}</li>;
						})}
					</ul>
				</div>
				<p>Aun no hay datos para mostrar</p>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<div className="options">
				<button
					onClick={() => {
						setTypeChart('bar');
					}}
					className={typeChart === 'bar' ? 'selected' : ''}
				>
					<i className="fas fa-chart-bar" />
				</button>
				<button
					onClick={() => {
						setTypeChart('polar');
					}}
					className={typeChart === 'polar' ? 'selected' : ''}
				>
					<i className="fas fa-chart-pie" />
				</button>
				<button
					onClick={() => {
						setTypeChart('doughnout');
					}}
					className={typeChart === 'doughnout' ? 'selected' : ''}
				>
					<i className="fas fa-circle-notch" />
				</button>
				<button
					onClick={() => {
						props.onDetails(props.surverId);
					}}
					className="details"
				>
					Ver Detalles
				</button>
			</div>

			<GetChart type={typeChart} data={props.data} options={{}} />

			{total > 0 && (
				<div className="results">
					{props.data.labels.map((label, index) => {
						const counter = props.data.data[index];
						return (
							<div className="result" key={label}>
								<i
									className="fas fa-square"
									style={{ color: getColor(index) }}
								/>
								<label>{label}</label>
								<label>{counter} votos</label>
								<label>{Math.floor((counter * 100) / total)} %</label>
							</div>
						);
					})}
				</div>
			)}
		</React.Fragment>
	);
}

export default Chart;

function GetChart(props) {
	const colors = {
		backgroundColor: [],
		borderColor: [],
	};
	props.data.labels.forEach((element, index) => {
		colors.backgroundColor.push(getColor(index, 0.6));
		colors.borderColor.push(getColor(index, 1));
	});

	const chartData = {
		labels: props.data.labels,
		datasets: [
			{
				label: [''],
				...colors,
				data: props.data.data,
			},
		],
	};

	if (props.type === 'bar') {
		return (
			<Bar
				data={chartData}
				options={{ 
					scales: { 
						y: { 
							beginAtZero: true 
						} 
					},
					plugins: {
						legend: { display: false }
					}
				}}
			/>
		);
	}

	if (props.type === 'doughnout') {
		return <Doughnut data={chartData} options={{}} />;
	}

	return <PolarArea data={chartData} options={{}} />;
}
